import { render } from "./MicrosoftComp.vue?vue&type=template&id=b3726b4a"
import script from "./MicrosoftComp.vue?vue&type=script&lang=js"
export * from "./MicrosoftComp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__